/* eslint-disable */

import axios from '../utils/request';

// 登录
export const toLogin = ({ email, password, google }) => axios({
  url: '/user/auth',
  method: 'post',
  data: {
    email,
    password,
    google,
  },
});
// 获取用户信息
export const getUserInfo = () => axios({
  url: '/user/profile/',
  method: 'get',
});

// 用户登出
export const logout = () => axios({
  url: '/user/logout/',
  method: 'post',
});
// 修改密码
export const updatePwd = ({ oldPassword, password }) => axios({
  url: '/user/resetpwd/',
  method: 'post',
  data: { oldPassword, password },
});

// 产品列表
export const productList = ({
  page, limit, start_date, end_date, name,
}) => axios.get(
  '/product/lists',{
  params: {
    page, limit, start_date, end_date, name,
  },
});

// 返回所有产品
export const allProductList = ({ page, limit }) => axios.get('/product/all', {
  params: {
    page, limit
  },
});

export const productDetail = (pid) => axios.get(`/product/detail/${pid}`);


// 配置策略管理
export const configCN = (data) => axios({
  // url: '/host/edit',
  url: '/product/edit',
  method: 'post',
  data,
});


// 新增内部名单IP（IP黑/白名单）
// http:/domain/api/front/product/addInterIP
export const productAddInterIP = (data) => axios({
  // url: '/host/edit',
  url: '/product/addInterIP',
  method: 'post',
  data,
});


// 删除内部名单IP（IP黑/白名单）
// http:/domain/api/front/product/deleteInterIP
export const productDeleteInterIP = (data) => axios({
  url: '/product/deleteInterIP',
  method: 'post',
  data,
})

// 主域名列表
export const mainDomainList = ({
  page, limit, 
  start_date, end_date, 
  pid, sub_host, states
}) => axios.get(
  '/subhost/lists', {
  params: {
    page, limit,
    start_date, end_date,
    pid, sub_host, states
  },
  },
);

export const apiGetDetail = (type, key) => axios.get(`/${type}/detail/${key}`);

// 配置主域名配置
export const apiCommonEdit = (type, data) => axios({
  url: '/' + type + '/edit',
  method: 'post',
  data,
});

// 新增名单IP（IP黑/白名单）
// http:/domain/api/front/subhost/addInterIP
export const apiAddInterIP = (type, data) => axios({
  url: '/'+ type + '/addInterIP',
  method: 'post',
  data,
});

// 删除黑名单
export const apiDeleteInterIP = (type, data) => axios({
  url: '/' + type + '/deleteInterIP',
  method: 'post',
  data,
})

// 查询IP白名单

// 删除subhost
export const apiSubhostDelete = (data) => axios({
  url: '/subhost/delete',
  method: 'post',
  data,
});


// 攻击预警
export const hitYJ = ({
  page, limit,
  start_date, end_date, 
  host
}) => axios.get('/attack/lists', {
  params: {
    page, limit,
    start_date, end_date,
    host
  },
});

// 子域名列表
export const childDomainList = ({page, limit,
  start_date, end_date,
  sub_host
 }) => axios.get('/host/lists', {
   params: {
     page, limit,
     start_date, end_date,
     sub_host
  },
})

// 新增子域名
export const addNewChildDomain = ({ subhosts, upstreams}) => axios({
  url: '/host/adds',
  method: 'post',
  data: {
    subhosts, upstreams
  },
});

// 证书列表
export const certList = ({
  page, limit,
  start_date, end_date,
  host,
  ssl_type, auto_ssl, ssl_state
 }) => axios.get('/cert/lists', {
   params: {
     page, limit,
     start_date, end_date,
     host,
     ssl_type, auto_ssl, ssl_state
  }
});

// 登录日志
export const loginLogList = ({
  page, limit,
  start_date, end_date,
}) => axios.get('/logs/login/lists', {
  params: {
    page, limit,
    start_date, end_date,
  }
});


// 操作日志
export const operLogList = ({
  page, limit,
  start_date, end_date,
}) => axios.get('/logs/operation/lists', {
  params: {
    page, limit,
    start_date, end_date,
  }
});

// 新增主域名
export const addMainDomain = ({ subhosts, pid }) => axios({
  url: '/subhost/adds',
  method: 'post',
  data: {
    subhosts, pid
  },
});


// 新增跳转
export const addRetic = ({
  sub_host,
  scheme,
  http_code,
  prefix_host,
  suffix_host,
  redirectUri,
}) => axios({
  url: '/subhost/rewrite/add',
  method: 'post',
  data: {
    sub_host,
    scheme,
    http_code,
    prefix_host,
    suffix_host,
    redirectUri,
  },
});

// 跳转列表
export const ReticList = ({
  page, limit, sub_host
}) => axios.get('/subhost/rewrite/lists', {
  params: {
    page, limit, sub_host
  },
})

// 修改跳转
export const updateRetic = ({
  rcondUri, http_code, redirectUri
}) => axios({
  url: '/subhost/rewrite/add',
  method: 'post',
  data: {
    rcondUri, http_code, redirectUri
  },
});

// 删除跳转
export const delRetic = ({
  id
}) => axios({
  url: `/subhost/rewrite/delete/${id}`,
  method: 'post',
});

// 子域名统计
export const childStatic = ({
  func,
  host, interval_time, interval_day,
}) => axios.get('/host/statics', {
  params: {
    func,
    host, interval_time, interval_day,
  },
});

// 统计
export const apiGetStatic = (name, data) => axios.get('/' + name + '/statics', {
  params: data,
});


// 配置主域名配置
export const configMainCn = (data) => axios({
  url: '/subhost/edit',
  method: 'post',
  data,
});

// 配置主域名配置
export const apiHostEdit = (data) => axios({
  url: '/host/edit',
  method: 'post',
  data,
});

// 批量操作
export const apiSubhostBatchEdit = (data) => axios({
  url: '/subhost/batchEdit',
  method: 'post',
  data,
});

// 主域名申请证书
export const apiSubhostApplyCert = (data) => axios({
  url: '/subhost/autoCommitSSL',
  method: 'post',
  data,
});

// 查询IP白名单

export const queryIPBalck = ({
  host,
  type,
}) => axios.get('/host/interips', {
  params: {
    host,
    type,
  },
});

// 新增白黑名单
export const addIPBalck = ({ ip, host, type }) => axios({
  url: '/host/addInterIP',
  method: 'post',
  data: {
    ip, host, type
  }
});

// 删除黑名单
export const delIPBalck = ({ ip, host, type }) => axios({
  url: '/host/deleteInterIP',
  method: 'post',
  data: {
    ip, host, type
  }
})
// 子域名日志
export const visitLog = ({ host, page, limit }) => axios.get('/host/accessLog', {
  params: {
    host, page, limit
  },
});

// 国家列表
export const countryList = () => axios.get('/area/lists');

// 子域名详情
export const childDomainDetail = (id) => axios.get(`/host/detail/${id}`);

// 子域名申请
export const applyChildCert = ({ host, dnstype }) => axios({
  url: '',
  method: 'post',
  data: {

  }
});
// 上传证书
export const uploadCert = ({ ssl_cert, ssl_key, host }) => axios({
  url: '/cert/submitCert',
  method: 'post',
  data: {
    ssl_cert, ssl_key, host
  }
});

// 上传解析证书文件
export const uploadCertFile = (data) => axios({
  url: '/cert/uploadCert',
  method: 'post',
  data,
  headers: {
    "Content-Type" :"multipart/form-data"
  }
});

// 批量上传证书
export const apiSubmitCerts = (data) => axios({
  url: '/cert/submitCerts',
  method: 'post',
  data
});

// 申请证书
export const applyCert = (host, dnstype) => axios({
  url: '/cert/autoCommitSSL',
  method: 'post',
  data: {
    host,
    dnstype
  }
});

// Re申请证书
export const ReApplyCert = (host) => axios({
  url: '/cert/reAutoCommitSSL',
  method: 'post',
  data: {
    host
  }
});

// 删除证书
export const apiDeleteCert = (host) => axios({
  url: '/cert/deleteCert',
  method: 'post',
  data: {
    host
  }
});


// 查证书
export const apiCertDetail = (host) => axios.get(
  '/cert/detail', {
  params: {
    host
  },
});

// 除删子域名
export const delChildDomain = ({ host, password }) => axios({
  url: '/host/delete',
  method: 'post',
  data: {
    host, password
  }
})

// host批量操作
export const apiHostBatchEdit = (data) => axios({
  url: '/host/batchEdit',
  method: 'post',
  data,
});

// top10流量
export const TopTenLLChart = () => axios.get('/user/indexCharts');

// 命中率 流量
export const TopOtherTJ = (params) => axios.get('/user/indexStatics', {
  params
})

// 攻击预警 TOP10 域名连接数
export const hostConnection = (host) => axios.get('/user/hostConnections', {
  params: {
    host
  }
});

// 首页统计
export const homeStatic = () => axios.get('/user/index');


export const apiGoogleCodes = () => axios({
  url: '/google/codes',
  method: 'post',
})

export const apiGoogleBinds = (data) => axios({
  url: '/google/binds',
  method: 'post',
  data
})
